<template>
  <Dashboard grafana-path="/d/ZryBVusUO/fico-following-distance-pivot" />
</template>

<script>
// @ is an alias to /src
import Dashboard from "@/components/Dashboard.vue";

export default {
  name: "FicoFollowingDistanceDriverPivot",

  routing: {
    localizationKey: "menu.tab.following_distance",
    icon: "mdi-table",
    path: "/fico_following_distance",
    hasAccess: (user) => user.isAdmin || user.isManager,
  },

  components: {
    Dashboard,
  },
};
</script>
